export default (props = {}) => <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg"{...props}>
<path d="M20.0241 7.63317L9.92937 17.7278L3.97656 11.775L5.83275 9.99615L9.92937 14.3827L18.2718 6L20.0241 7.63317Z"/>
</svg>
